import { RegistrationLayout } from "./";

export const PostSweeps = ({ registered = false, ...props }) => {
  return <RegistrationLayout postSweeps registered={registered} {...props} />;
};
